module.exports = __webpack_public_path__ + "img/login+signup.d6ce9a2b.png";